module.exports = __webpack_public_path__ + "img/supplyChain.d48840f1.png";